import GoldBadge from '../../../../static/partner-badges/gold.svg';
import PlatinumBadge from '../../../../static/partner-badges/platinum.svg';
import SilverBadge from '../../../../static/partner-badges/silver.svg';

/**
 * @param {import('@action-types/ecPublisher').EcPublisherInfoResponse['partnerLevel']} [partnerLevel]
 */
export const getPartnerBadgeImage = (partnerLevel) => {
  if (!partnerLevel) {
    return null;
  }
  const partnerBadges = {
    silver: `${SilverBadge.match(/^\//) ? SilverBadge : `/${SilverBadge}`}`,
    gold: `${GoldBadge.match(/^\//) ? GoldBadge : `/${GoldBadge}`}`,
    platinum: `${PlatinumBadge.match(/^\//) ? PlatinumBadge : `/${PlatinumBadge}`}`,
  };
  const lowercased = partnerLevel?.toLowerCase();
  for (const partnerLevel of Object.keys(partnerBadges)) {
    if (lowercased?.includes(partnerLevel)) {
      return partnerBadges[partnerLevel];
    }
  }
};
